module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00019-fs8.4a414a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00019-fs8.png
// module id = 172
// module chunks = 0